<script>
import Layout from '@layout/main'
import SectionFeatures from './components/SectionFeatures'
import SectionList from './components/SectionList'
import SectionContact from './components/SectionContact'
import SectionSwiperFeatures from './components/SectionSwiperFeatures'


export default {
  page() {
    return {
      title: '系統行銷整合方案',
    }
  },
  components: {
    Layout,
    SectionList,
    SectionFeatures,
    SectionContact,
    SectionSwiperFeatures
  },
}
</script>
<template>
  <Layout>
    <div class="header__bg">
      <BaseBannerTitle 
        title="系統行銷整合方案" 
        sub-title="Intermediate Plan" 
      />
    </div>
    <div class="container">
      <BaseBlock
        title="在預約系統方案的基礎上搭配專業的行銷團隊<br>絕對會是您的最佳選擇"
        class="isStylePrimary intermediatePlanBlock"
      />
    </div>
    <SectionFeatures/>
    <!-- <SectionList/> -->
    <SectionSwiperFeatures/>
    <SectionContact/>
  </Layout>
</template>
<style lang="scss" scoped>
.intermediatePlanBlock {
  margin-top: -3rem;
  @include max-lg {
    margin-top: 7rem;
  }
}
</style>